import {gql} from 'apollo-boost';

export const GET_STAFFS = gql`
  query {
    getStaffs{
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      telephone
      email
      picturePath
      isActive
    }
  }
`;

export const GET_STAFFS_DDL = gql`
  query {
    getStaffs{
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      telephone
      email
      picturePath
      isActive
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      label
    }
  }
`;

export const GET_STAFFS_BY_FILTER = gql`
  query getStaffsByFilter($staffFilterInput: StaffFilterInput){
    getStaffsByFilter(
      staffFilterInput : $staffFilterInput
    ){
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      telephone
      email
      picturePath
      isActive
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      label
    }
  }
`;

export const GET_STAFF = gql`
  query getStaff($id : ID!){
    getStaff (
      id: $id
    ) {
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      telephone
      email
      picturePath
      isActive
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      user{
        id
        code
        userLogin
        userGroup{
          id
          code
          nameLocal
          nameEng
        }
        email
      }
    }
  }
`;

export const ADD_STAFF = gql`
  mutation addStaff(
    $staffInput: StaffInput!,
    $prefixId: ID!,
    $userId: ID,
  ) {
    addStaff(
      staffInput: $staffInput
      prefixId: $prefixId
      userId: $userId
    ) {
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      telephone
      email
      picturePath
      isActive
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      user{
        id
        code
        userLogin
        userGroup{
          id
          code
          nameLocal
          nameEng
        }
        email
      }
    }
  }
`;

export const UPDATE_STAFF = gql`
  mutation updateStaff(
    $id: ID!,
    $staffInput: StaffInput!,
    $prefixId: ID!,
    $userId: ID,
  ) {
    updateStaff(
      id: $id
      staffInput: $staffInput
      prefixId: $prefixId
      userId: $userId
    ) {
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      telephone
      email
      picturePath
      isActive
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      user{
        id
        code
        userLogin
        userGroup{
          id
          code
          nameLocal
          nameEng
        }
        email
      }
    }
  }
`;

export const DELETE_STAFF = gql`
  mutation deleteStaff($id: ID!) {
    deleteStaff(
      id: $id
    ) {
      id
      code
      firstNameLocal
      lastNameLocal
      firstNameEng
      lastNameEng
      telephone
      email
      picturePath
      isActive
      prefix{
        id
        nameLocal
        nameEng
        nameShortLocal
        nameShortEng
      }
      user{
        id
        code
        userLogin
        userGroup{
          id
          code
          nameLocal
          nameEng
        }
        email
      }
    }
  }
`;

